// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"232":"566461d3","602":"566461d3"}[chunkId] + ".chunk.css";
};